import { render, staticRenderFns } from "./brands-page.vue?vue&type=template&id=46f565d9&"
import script from "./brands-page.vue?vue&type=script&lang=js&"
export * from "./brands-page.vue?vue&type=script&lang=js&"
import style0 from "./brands-page.vue?vue&type=style&index=0&id=46f565d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports